<template>
    <el-dialog :title="type === 'edit' ? '编辑作业' : '布置作业'" width="760px" center :close-on-click-modal="false" :visible="show"
        @close="close">
        <div class="work-title">
            <el-input type="text" maxlength="20" v-model="title" placeholder="请输入作业标题" />
            <span>{{ title.length }}/20</span>
        </div>
        <div class="work-contanier">
            <div class="work-txt">
                <el-input ref="content" type="textarea" resize="none" class="work-content" maxlength="1000" :rows="12"
                    show-word-limit v-model="content" placeholder="输入作业内容..." />
                <text class="work-txt-length">{{ content.length }}/1000</text>
            </div>
            <!-- 语音资源 -->
            <!-- <div class="audio">
                <TestAudio v-if="isShowAudioPlayer" :isShowAudioPlayer="isShowAudioPlayer" :audio="audio" @closeAudioPlay="closeAudioPlay"></TestAudio>
            </div> -->
            <!-- 图片资源 -->
            <!-- <div class="work-photos">
                <div class="one-photo" v-for="(item,index) in thumb_photos" :key="index">
                    <el-image :src="backImgUrl(item)"  :preview-src-list="photos"/>
                    <img @click="deletePhoto(index)" class="delete_img" src="@/assets/housework/delete.png" alt="">
                </div>           
            </div> -->
            <!--添加资源 -->
            <upload-file :hasphotos="photos" :hasthumb="thumb_photos" :voice="audio" @addSource="addSource"></upload-file>
        </div>
        <div slot="footer">
            <el-button plain @click="close">取消</el-button>
            <el-button type="primary" @click="save">完成</el-button>
        </div>

    </el-dialog>
</template>

<script>
import API_CONFIG from "../../../../../../config/index"
import TestAudio from "../../components/TestAudio.vue"
import UploadFile from "../UploadFile.vue"
export default {
    components: { TestAudio, UploadFile },
    data () {
        return {
            title: '', // 作业标题
            content: '', // 作业描述内容
            photos: [], // 上传图片
            thumb_photos: [], //缩略图
            baseURL: '',
            audio: '', // 音频资源
            isShowAudioPlayer: false, //是否显示音频播放器
        }
    },
    props: {
        show: {
            type: Boolean,
            require: true
        },
        detailData: [Object],
        type: {
            type: String,
            default: 'create'
        }
    },
    mounted () {
        this.initTitle()
        this.baseURL = API_CONFIG.dev.proxyTable['/api'].target
        if (this.type === 'edit') {
            const { title, content, voice, images, thumbs } = this.detailData
            this.title = title
            this.content = content
            this.audio = voice
            this.photos = images
            this.thumb_photos = thumbs
            this.isShowAudioPlayer = true
        }
    },
    methods: {
        initTitle () {
            const date = new Date()
            const year = date.getFullYear()
            const month = date.getMonth() > 9 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)
            const day = date.getDate() > 9 ? date.getDate() : '0' + (date.getDate())
            this.title = `${year}.${month}.${day}作业`
        },
        close () {
            this.$emit('close')
        },
        // // 删除语音
        // closeAudioPlay() {
        //     this.audio = ''
        //     this.isShowAudioPlayer = false
        // },
        // // 删除图片
        // deletePhoto(index) {
        //     this.thumb_photos.splice(index,1)
        //     this.photos.splice(index,1)
        // },

        // 上传文件
        addSource (data) {
            const file = data
            if (file.type === 'img') {
                const { thumb_photos, photos } = file
                this.thumb_photos = thumb_photos
                this.photos = photos
            } else {
                const { audio } = file
                this.audio = audio
                this.isShowAudioPlayer = true
            }
        },
        // 保存布置的作业内容
        async save () {
            const work_id = this.$route.query.id
            const photos = this.photos.length > 0 ? this.photos.join(',') : ''
            const thumbs = this.thumb_photos.length > 0 ? this.thumb_photos.join(',') : ''
            const formData = {
                title: this.title,
                content: this.content,
                class_id: localStorage.getItem('class_id'),
                course_id: localStorage.getItem('course_id'),
                images: photos,
                thumbs: thumbs,
                voice_length: 0,
                voice_play_length: 0,
                voice: this.audio,
                work_id: work_id,

            }
            if (!this.content) {
                this.$message.warning('请输入作业内容')
                this.$refs.content.focus()
                return
            }
            const url = this.type === 'create' ? '/base/homework/create' : '/base/homework/update'
            const { data: res } = await this.$axios.post(url, formData)
            if (res.errCode === 0) {
                this.$emit('updateHousework')
            } else {
                this.$message.error(res.message)
            }
        },

        // 返回的图片链接
        backImgUrl (item) {
            const str = 'http'
            if (item.indexOf(str) !== -1) {
                return item
            } else {
                return this.baseURL + item
            }
        }
    }

}
</script>

<style lang="scss" scoped>
@import '@/assets/css/housework.scss';

.el-dialog {
    .el-dialog__body {
        .work-title {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 45px;
            line-height: 45px;
            border-bottom: 1px solid #E6EAEE;
            box-sizing: border-box;

            span {
                color: #CBD2D9;
            }

            .el-input {
                width: 80%;
                height: 45px;
                display: inline-block;
                border: none;
                font-size: 18px;
                color: #262C31;

                /deep/ .el-input__inner {
                    border: none;
                }
            }
        }


        // 作业内容
        // .work-contanier {
        //     margin-top: 20px;
        //     border: 1px solid #D8E2EB;
        //     border-radius: 4px;

        //     .work-txt {
        //         margin-top: 20px;
        //         height: auto;

        //         .work-content {
        //             /deep/ .el-textarea__inner {
        //                 border: none;
        //             }
        //         }
        //     }

        //     .audio {
        //         margin: 16px;
        //     }

        //     .work-photos {
        //         display: flex;
        //         .one-photo{
        //             position: relative;
        //             margin: 16px 0 16px 16px;
        //             width: 60px;
        //             height: 60px;

        //             img {
        //                 width: 100%;
        //                 height: 100%;
        //                 // width: 100%;
        //                 // margin: 16px 0 0 16px;
        //             }
        //             .delete_img {
        //                 position: absolute;
        //                 top:0;
        //                 right: 0px;
        //                 width: 16px;
        //                 height: 16px;

        //             }
        //         }

        //     }

        //     .work-add-resourse {
        //         display: flex;

        //         div {
        //             // display: flex;
        //             // flex-direction: column;
        //             // align-items: center;
        //             // justify-content: center;
        //             width: 64px;
        //             height: 64px;
        //             border-radius: 4px;
        //             font-size: 10px;
        //             color: #BFC4C8;
        //             text-align: center;
        //             background: #F5F7F8;
        //             margin-left: 16px;
        //             margin: 0 0 16px 16px;
        //             >>>.el-upload {
        //                 display: flex;
        //                 flex-direction: column;
        //                 align-items: center;
        //                 justify-content: center;
        //                 margin-top: 12px;

        //             }
        //             // >>>.el-upload img {
        //             //     margin-bottom: 4px;
        //             //     width: 24px;
        //             //     height: 24px;
        //             // }

        //         }
        //     }
        // }

    }

    // footer
    .el-dialog__footer {
        text-align: center;

        .el-button {
            width: 98px;
            height: 40px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/view/Panel/housework/components/list/AssignHomework.vue